import { Link } from "gatsby";
import React from "react";
import { ABOUT_ROUTE, CONTACT_ROUTE } from "../constants";
import LayoutContainer from "./LayoutContainer";
import Logo from "./Logo";
import SocialButtons from "./SocialButtons";
import WavefoundryIcon from "./WavefoundryIcon";
import WaveSVG from "./WaveSVG";

const footerLinks = [
  {
    label: "CONTACT US",
    to: CONTACT_ROUTE,
  },
  {
    label: "ABOUT US",
    to: ABOUT_ROUTE,
  },
];
const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 relative">
      <div className="footer-svg-container text-gray-900">
        <WaveSVG />
      </div>
      <LayoutContainer>
        <div className="flex justify-between items-center flex-col lg:flex-row">
          <div className="flex flex-col lg:flex-row">
            <div>
              <div>
                <Link to="/">
                  <div className="w-32 m-auto">
                    <Logo />
                  </div>
                </Link>
              </div>
            </div>
            <div className="flex ml-0 lg:ml-4 flex-col lg:flex-row items-center my-2 lg:my-0 py-2 lg:py-0">
              {footerLinks.map(({ label, to }) => {
                return (
                  <div key={to} className="ml-0 lg:ml-4 my-1 lg:my-0">
                    <Link
                      to={to}
                      className="transition-colors transition-duration-150 text-gray-200 hover:text-white text-sm"
                    >
                      {label}
                    </Link>
                  </div>
                );
              })}
              <div className="ml-0 lg:ml-4 my-1 lg:my-0">
                <a
                  href="https://philipsacademync.org"
                  className="transition-colors transition-duration-150 text-gray-200 hover:text-white text-sm"
                >
                  PHILIPS ACADEMY HOME
                </a>
              </div>
            </div>
          </div>
          <div>
            <SocialButtons
              bgColor="bg-primary-700"
              bgHoverColor="bg-primary-800"
            />
          </div>
        </div>
        <div className="flex justify-between flex-wrap items-center mt-6">
          <div className="w-full lg:w-1/2">
            <p className="font-size-12 tracking-wide text-gray-300 text-center lg:text-left opacity-75">
              © Copyright {new Date().getFullYear()} · All Rights Reserved ·
              Philips Academy of Charlotte, NC
            </p>
          </div>
          <div className="w-full lg:w-1/2 text-center lg:text-right mt-2 lg:mt-0">
            <a
              href="https://wavefoundry.io"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center font-size-12 text-white opacity-50 hover:opacity-100 focus:opacity-100 transition-opacity transition-duration-150"
            >
              <div className="mr-1">
                <WavefoundryIcon />
              </div>
              <div>Powered by Wavefoundry</div>
            </a>
          </div>
        </div>
      </LayoutContainer>
    </footer>
  );
};

export default Footer;
